export default "__VITE_ASSET__DePW9$S4__"